import * as Yup from 'yup';

export const createSchema = Yup.object().shape({
  name: Yup.string().required('Preencha com seu nome completo'),
  email: Yup.string().required('Preencha com seu email'),
  // company: Yup.string().required('Preencha a sua empresa'),
  message: Yup.string().required('Preencha a mensagem'),
});
